export default __webpack_public_path__ + "b64fc693183d9dc55f65f750c93ff37e.webp";